import React from 'react'
import { BasicSEO, OpenGraph } from '@sentecacommerce-theme/lib'
import { SeoModuleProps } from './seomodule.props'

export const SeoModule = (props: SeoModuleProps) => {
  const {
    title,
    description,
    keywords,
    image = 'https://production.hippoland-contents.com/platform/media/157019966009-5fd0db60e77de40011d8803a.jpeg',
  } = props
  return (
    <>
      <BasicSEO
        title={title}
        description={description}
        keywords={keywords}
      />
      <OpenGraph
        title={title}
        type="website"
        image={image}
        additionalProps={[
          {
            key: 'description',
            value: description,
          },
        ]}
      />
    </>
  )
}
